export enum DateTimeRangeError {
    StartAfterEnd = 'StartAfterEnd',
}
